import {
  CalendarPlus,
  CalendarCheck,
  CalendarX,
  Building2,
  Building,
  UserPlus,
  Clock,
  LayoutGrid,
  Map,
  Settings,
  Contact,
  Mail,
  Plus,
  Pencil,
  Trash2,
  Tag,
} from "lucide-mui"
import { type ElementType } from "react"

type ActivityKey =
  | "reservation.created"
  | "reservation.updated"
  | "reservation.removed"
  | "venue.created"
  | "venue.updated"
  | "venue.updated_working_hours"
  | "venue.updated_layout"
  | "venue.plans_updated"
  | "venue.updated_reservation_configuration"
  | "venue.updated_tags"
  | "account.created"
  | "customer.contact_updated"
  | "customer.email_sent"

export const DEFAULT_ACTION_ICONS: Record<string, ElementType> = {
  created: Plus,
  updated: Pencil,
  removed: Trash2,
}

export const ACTIVITY_ICONS: Record<ActivityKey, ElementType> = {
  "reservation.created": CalendarPlus,
  "reservation.updated": CalendarCheck,
  "reservation.removed": CalendarX,
  "venue.created": Building2,
  "venue.updated": Building,
  "venue.updated_working_hours": Clock,
  "venue.updated_layout": LayoutGrid,
  "venue.plans_updated": Map,
  "venue.updated_reservation_configuration": Settings,
  "venue.updated_tags": Tag,
  "account.created": UserPlus,
  "customer.contact_updated": Contact,
  "customer.email_sent": Mail,
}

export const getActivityIcon = (activityKey: string): ElementType => {
  if (activityKey in ACTIVITY_ICONS) {
    return ACTIVITY_ICONS[activityKey as ActivityKey]
  }

  const action = activityKey.split(".").pop() || ""
  if (action in DEFAULT_ACTION_ICONS) {
    return DEFAULT_ACTION_ICONS[action]
  }

  return Pencil
}
